'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getMaxPage = function (current, total) {
    if (current + 1 <= total) {
        return current + 1;
    }
    return current;
};
var getMinPage = function (current, min) {
    if (current - 1 >= min) {
        return current - 1;
    }
    return min;
};
var buttonValues = function (currentPage, rows, rowsPPage) {
    var pages = Math.ceil(rows / rowsPPage) - 1;
    var max = getMaxPage(currentPage, pages);
    var min = getMinPage(currentPage, 0);
    var current = min;
    var result = [];
    if (min > 0) {
        result.push({ value: 1, goTo: 1 });
    }
    if (min > 1) {
        var goTo = Math.ceil((min + 1) / 2);
        result.push({ value: goTo === 2 ? 2 : '...', goTo: goTo });
    }
    while (current <= max) {
        result.push({
            value: current + 1,
            goTo: current + 1,
        });
        current += 1;
    }
    var lastElementValue = result[result.length - 1].goTo;
    if (lastElementValue < Math.floor(pages)) {
        var goTo = Math.ceil((pages + lastElementValue) / 2);
        result.push({ value: goTo === Math.floor(pages) ? goTo : '...', goTo: goTo });
    }
    if (lastElementValue < Math.floor(pages) + 1) {
        result.push({ value: Math.floor(pages) + 1, goTo: Math.floor(pages) + 1 });
    }
    return result;
};

exports.buttonValues = buttonValues;
